import React from 'react'

import Button from '../Button/Button'
import Link from '../Link'

const WebsiteButton = ({ website }) => (
  <Button
    type='secondary'
    as={Link}
    href={website}
    target='_blank'
    trackingData={{ event: 'Open Apartment Website' }}
  >
    Check Availability
  </Button>
)

export default WebsiteButton
